import React, {
	memo,
	useCallback,
	useMemo,
	useRef
} from 'react';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import { log } from '../../services/utils';

import {
	useUIState,
	useUIAction
} from '../../contexts/UIContext';

import AdministrationSidebar from './AdministrationSidebar';
import AgenciesSidebar from './AgenciesSidebar';
import OperationsSidebar from './OperationsSidebar';

import styles from './sidebar.module.css';

const Sidebar = () => {
	const {
		sidebar,
		sidebarMenu,
		sidebarToggle
	} = useUIState();
	const { setSidebar } = useUIAction();

	const nodeRef = useRef( null );

	const toggleRef = useRef( null );

	const handleSidebarOpen = useCallback( () => {
		setSidebar( true );
	}, [ setSidebar ] );

	const handleSidebarClose = useCallback( () => {
		setSidebar( false );
	}, [ setSidebar ] );

	const sidebarClassNames = useMemo( () => ( {
		enter: styles.sidebarEnter,
		enterActive: styles.sidebarEnterActive,
		enterDone: styles.sidebarEnterDone,
		exit: styles.sidebarExit,
		exitActive: styles.sidebarExitActive,
		exitDone: styles.sidebarExitDone
	} ), [] );

	const toggleClassNames = useMemo( () => ( {
		enter: styles.sidebarToggleEnter,
		enterActive: styles.sidebarToggleEnterActive,
		enterDone: styles.sidebarToggleEnterDone,
		exit: styles.sidebarToggleExit,
		exitActive: styles.sidebarToggleExitActive,
		exitDone: styles.sidebarToggleExitDone
	} ), [] );

	// const toggleOnEnter = useCallback( node => {
	// 	console.dir( node );
	// 	node.style.display = 'initial';
	// }, [] );

	// const toggleOnExit = useCallback( node => {
	// 	setTimeout( () => {
	// 		node.style.display = 'none';
	// 	}, 500 );
	// }, [] );

	const toggleTimeout = useMemo( () => ( {
		enter: 500,
		exit: 500
	} ), [] );

	const renderSidebarRoutes = useCallback( () => {
		switch ( sidebarMenu ) {
			case 'operations':
				return <div className={ styles.sidebarRoutesContainer }>
					<Icon
						className={ styles.sidebarToggleClose }
						name="chevron left"
						onClick={ handleSidebarClose }
						size="big"
					/>
					<OperationsSidebar />
				</div>;
			case 'agencies':
				return <div className={ styles.sidebarRoutesContainer }>
					<Icon
						className={ styles.sidebarToggleClose }
						name="chevron left"
						onClick={ handleSidebarClose }
						size="big"
					/>
					<AgenciesSidebar />
				</div>;
			case 'administration':
				return <div className={ styles.sidebarRoutesContainer }>
					<Icon
						className={ styles.sidebarToggleClose }
						name="chevron left"
						onClick={ handleSidebarClose }
						size="big"
					/>
					<AdministrationSidebar />
				</div>;
			default:
				return null;
		}
	}, [
		handleSidebarClose,
		sidebarMenu
	] );

	return (
		<>
			{ log( 'sidebar' )}
			<CSSTransition
				classNames={ sidebarClassNames }
				in={ Boolean( sidebar ) }
				nodeRef={ nodeRef }
				key="sidebar"
				timeout={ 0 }
			>
				<div
					className={ `${ styles.sidebar } no-print` }
					ref={ nodeRef }
				>
					{ renderSidebarRoutes() }
					<CSSTransition
						classNames={ toggleClassNames }
						in={ sidebarToggle }
						key="sidebarToggle"
						nodeRef={ toggleRef }
						// onEnter={ toggleOnEnter }
						// onExited={ toggleOnExit }
						timeout={ toggleTimeout }
					>
						<div
							className={ styles.sidebarToggleOpen }
							onClick={ handleSidebarOpen }
							ref={ toggleRef }
						>
							<Icon
								name="bars"
								size="big"
							/>
						</div>
					</CSSTransition>
				</div>
			</CSSTransition>
		</>
	);
};

Sidebar.propTypes = {
	open: PropTypes.bool,
	sidebarToggle: PropTypes.func
};

export default memo( Sidebar );
